import { WindowsBtnContextInterface } from "./WindowBtnContext";
import { IRuntimeContext } from "./RuntimeContext";
import React, { createContext, FC } from "react";

export const WindowsSystemBtnContext = createContext<WindowsBtnContextInterface | undefined>(
    undefined,
);
export const RuntimeContext = createContext<IRuntimeContext | undefined>(undefined);

interface StoreProviderProps {
    children: React.ReactNode;
    WindowsBtnContext?: WindowsBtnContextInterface;
    runtime?: IRuntimeContext;
}

export const StoreProvider: FC<StoreProviderProps> = ({ WindowsBtnContext, children, runtime }) => (
    <WindowsSystemBtnContext.Provider value={WindowsBtnContext}>
        <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>
    </WindowsSystemBtnContext.Provider>
);
